import { NumberFieldInput } from '@hex/calculators-shared/components/NumberFieldInput';
import { Stroller, Car } from '@sapphire/icons/react';
import { Icon, HelpButton, Typography  } from '@sapphire-react/core';
import React from 'react';
import { type Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  control: Control<any>;
};

export function HouseholdSection({ control }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <NumberFieldInput
        control={control}
        name={'children'}
        data-test-id={'children'}
        label={t('form.children.label')}
        width={'100%'}
        minValue={0}
        maxValue={5}
        showButtons
        affix={{
          prefix: (
            <Icon>
              <Stroller />
            </Icon>
          ),
        }}
      />

      <NumberFieldInput
        control={control}
        name={'cars'}
        data-test-id={'cars'}
        label={t('form.cars.label')}
        width={'100%'}
        minValue={0}
        maxValue={3}
        showButtons
        affix={{
          prefix: (
            <Icon>
              <Car />
            </Icon>
          ),
        }}
        contextualHelp={
          <HelpButton
            variant={'help'}
            aria-label={t('help')}
            contentBody={
              <Typography.Body size={'sm'} aria-live={'polite'}>
                {t('form.cars.tooltip')}
              </Typography.Body>
            }
          />
        }
      />
    </>
  );
}
